.banners {
  position: sticky;
  top: 52px;
  z-index: 15;
  display: grid;
  gap: var(--space-2);
  max-width: calc(var(--column-max) + 2 * var(--space-4));
  padding: var(--space-2) max(var(--space-4), env(safe-area-inset-left)) 0;
}

@media (min-width: 720px) {
  .banners {
    max-width: calc(var(--column-max) + 4 * var(--space-8));
    padding-inline: var(--space-8);
  }
}

@media (min-width: 1200px) {
  .banners {
    padding-inline: calc(2 * var(--space-8));
  }

  :global(body:has([data-column="larga"])) .banners {
    max-width: calc(var(--column-wide) + 4 * var(--space-8));
  }
}
